import { Pipe, PipeTransform } from '@angular/core';
import { ItemConfig } from '../../Models/ItemDisplay';

@Pipe({
  name: 'getValueByTypeConfig',
})
export class GetValueByTypeConfig implements PipeTransform {

  transform(type: number, list: ItemConfig[]): any {
    if (type !== null && type !== undefined) {
      return list.find(x => x.Type === type)?.Value;
    }
    return null;
  }

}
